export class SelectEnum {
  constructor(label = "", value = "") {
    this.label = label;
    this.value = value;
  }
}
export class SentenceViewModel {
  constructor(loading = false, result = "", html = "", like = 0, message = "") {
    this.loading = loading;
    this.result = result;
    this.html = html;
    this.like = like;
    this.message = message;
  }
}

export class SendPostData {
  constructor(cmd = "_5118_Send_Message_Content", btn, data = {}) {
    this.cmd = cmd;
    this.btn = btn;
    this.data = data;
  }
}

export class Pageable {
  constructor(pageIndex = 1, pageSize = 10) {
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;
  }
}
export class saveDoc {
  constructor() {
    this.docId = "";
    this.title = "";
    this.content = "";
    this.intro = "";
    this.folderId = 0;
    // this.userToken = "";
  }
}

export class styleMenu {
  constructor(menuName, menuDownList = []) {
    this.menuName = menuName;
    this.menuDownList = menuDownList;
  }
}

export class RestructureModel {
  constructor(like = "", value = "", loading) {
    this.like = like;
    this.value = value;
    this.loading = loading;
  }
}
